
export const fetchUtil = () => {

    const urlEntornoLocal = 'http://localhost:8080';
    const urlEntornoLambda = 'https://cgmoazbtxd.execute-api.us-east-1.amazonaws.com/Stage/unadmin';
    const urlDominioServidor = 'http://3.88.198.209:8080';

    const url = {
        1: {
            urlEntornoLocal,
            urlEntornoLambda,
            pathLambda: '/service/adminTe/obtieneResumenDashboardAdmin',
            urlDominioServidor
        },
        2: {
            urlEntornoLocal,
            urlEntornoLambda,
            pathLambda: '/service/agendaTe/registraClientes',
            urlDominioServidor
        },
        3: {
            urlEntornoLocal,
            urlEntornoLambda,
            pathLambda: '/service/agendaTe/registraCompanias',
            urlDominioServidor
        },
        4: {
            urlEntornoLocal,
            urlEntornoLambda,
            pathLambda: '/service/autenticacion/loginApp',
            urlDominioServidor
        },
        5: {
            urlEntornoLocal,
            urlEntornoLambda,
            pathLambda: '/service/autenticacion/activacionUsuarioApp',
            urlDominioServidor
        },
        6: {
            urlEntornoLocal,
            urlEntornoLambda,
            pathLambda: '/service/agendaTe/elementosPasarela',
            urlDominioServidor
        },
        7: {
            urlEntornoLocal,
            urlEntornoLambda,
            pathLambda: '/service/autenticacion/recuperaPass',
            urlDominioServidor
        },
        8: {
            urlEntornoLocal,
            urlEntornoLambda,
            pathLambda: '/service/agendaTe/obtieneAgendaDelDia',
            urlDominioServidor
        },
        9: {
            urlEntornoLocal,
            urlEntornoLambda,
            pathLambda: '/service/agendaTe/obtieneCatalogo',
            urlDominioServidor
        },
        10: {
            urlEntornoLocal,
            urlEntornoLambda,
            pathLambda: '/service/agendaTe/registraAgendamiento',
            urlDominioServidor
        },
        11: {
            urlEntornoLocal,
            urlEntornoLambda,
            pathLambda: '/service/agendaTe/obtieneListadoCitas',
            urlDominioServidor
        },
        12: {
            urlEntornoLocal,
            urlEntornoLambda,
            pathLambda: '/service/agendaTe/registraDisponibilidad',
            urlDominioServidor
        },
        13: {
            urlEntornoLocal,
            urlEntornoLambda,
            pathLambda: '/service/agendaTe/obtieneDisponibilidad',
            urlDominioServidor
        },
        14: {
            urlEntornoLocal,
            urlEntornoLambda,
            pathLambda: '/service/agendaTe/eliminaDisponibilidad',
            urlDominioServidor
        },
        15: {
            urlEntornoLocal,
            urlEntornoLambda,
            pathLambda: '/service/agendaTe/obtieneListadoClientes',
            urlDominioServidor
        },
        16: {
            urlEntornoLocal,
            urlEntornoLambda,
            pathLambda: '/service/agendaTe/registraServicios',
            urlDominioServidor
        },
        17: {
            urlEntornoLocal,
            urlEntornoLambda,
            pathLambda: '/service/agendaTe/obtieneListadoServicios',
            urlDominioServidor
        },
        18: {
            urlEntornoLocal,
            urlEntornoLambda,
            pathLambda: '/service/adminTe/obtieneListadoCompanys',
            urlDominioServidor
        },
        19: {
            urlEntornoLocal,
            urlEntornoLambda,
            pathLambda: '/service/adminTe/obtieneListadoCitasAdmin',
            urlDominioServidor
        },
        20: {
            urlEntornoLocal,
            urlEntornoLambda,
            pathLambda: '/service/agendaTe/registraProfesional',
            urlDominioServidor
        },
        21: {
            urlEntornoLocal,
            urlEntornoLambda,
            pathLambda: '/service/agendaTe/obtieneListadoProfesionales',
            urlDominioServidor
        },
        22: {
            urlEntornoLocal,
            urlEntornoLambda,
            pathLambda: '/service/agendaTe/obtieneListadoCitasCompany',
            urlDominioServidor
        },
        23: {
            urlEntornoLocal,
            urlEntornoLambda,
            pathLambda: '/service/agendaTe/obtieneDetalleCita',
            urlDominioServidor
        },
        24: {
            urlEntornoLocal,
            urlEntornoLambda,
            pathLambda: '/service/agendaTe/cancelaCita',
            urlDominioServidor
        }
    }

    return {
        apiLambda: true,
        url
    }

}